import { CampaignImpact, PartnershipBacked } from '../../enum/campaign-categorisation.enum';
import { CampaignDefaultView } from '../../enum/campaign-default-view.enum';
import { CampaignStatus } from '../../enum/campaign-status.enum';
import { CompanyInfo } from '../company/company-info';
import { Term } from '../share/term';

export class Campaign {
  id: number;
  campaignStatus: CampaignStatus;
  coInvestmentStatus?: string;
  campaignType: string;
  company: CompanyInfo;
  endAt: string;
  bankedInAmount: number;
  fundedAmount: number;
  investorCount: number;
  isAngelTaxIncentive: boolean;
  isCreator: boolean;
  isFavourite: boolean;
  isInvested: boolean;
  latestViewCount: number;
  maximumTargetAmount: number;
  minimumTargetAmount: number;
  preLiveEndAt: string;
  preLiveStartAt: string;
  raisedPercentage: number;
  slug: string;
  startAt: string;
  valuationAmount: number;
  overSubscriptionAmount: number;
  equityOffered: number;
  largestInvestmentAmount: number;
  lastPaidAmount: number;
  targetAmount: number;
  minimumLots: number;
  sharePerLot: number;
  pricePerShare: number;
  showDetails?: boolean;
  isEnded?: boolean;
  rssUrl: string;
  campaignFAQs: Term[];
  campaignRisks: Term[];
  isToday?: boolean;
  isTomorrow?: boolean;
  isShariah?: boolean;
  isPrivate?: boolean;
  isInvited?: boolean;
  pledgedInvestorCount: number;
  highlightBody?: string;
  highlightTitle?: string;
  highlightUrl?: string;
  campaignHighlights?: { id: number; content: string }[];
  videoUrl?: string;
  foundersUrl?: string;
  coolingPeriodEndAt?: string;
  shareType?: number;
  shareTypes?: number[];
  registrationLinkUrl?: string;
  partnershipBacked?: PartnershipBacked;
  campaignImpacts: CampaignImpact[];
  customHighlightMessage: string;
  showCustomHighlight: boolean;
  showCampaignData?: boolean;
  viewCount: number;
  QnACount?: number;
  EventsCount?: number;
  shareCount?: number;
  CTACount?: number;
  fileCount?: number;
  top2Counts?: { label: string; value: number }[];
  name: string;
  chatbotUrl?: string;
  isSummaryPagePublished?: boolean;
  // FRC-1035: listing only. Which view this campaign's discovery card opens, resolved by the backend.
  defaultView?: CampaignDefaultView;
}
